import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const orderModule = {
  namespaced: true,
  state: {
    orders: null,
    order: null,
    isLoading: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
  mutations,
  actions,
  getters,
};

export default orderModule;
